import styles from '../styles.module.css';
import downloadIcon from './../../../assets/img/download-logo.svg';
import fileIcon from './../../../assets/img/file-icon.svg';
import PropTypes from 'prop-types';

export const DownloadBox = ({ filename, fileSize, handleDownload }) => {
  return (
    <div className={styles.downloadBox} onClick={() => handleDownload()}>
      <div className={styles.fileIcon}>
        <img src={fileIcon} alt="file icon" width="32" height="32" />
      </div>
      <div className={styles.file}>
        <div className={styles.fileTitle}>{filename}</div>
        <div className={styles.fileSize}>{fileSize}</div>
      </div>
      <div className={styles.downloadIcon}>
        <img src={downloadIcon} alt="download icon" width="20" height="20" />
      </div>
    </div>
  );
};

DownloadBox.propTypes = {
  filename: PropTypes.string.isRequired,
  fileSize: PropTypes.string.isRequired,
  handleDownload: PropTypes.func.isRequired
};
